<header>
    <button class="menu-button" type="button" (click)="openMenu()">
        <svg class="kd-icon--l kd-icon--button" kdSldsIcon="rows"></svg>
    </button>
    
    <div class="branding">
        <a class="home-link" [title]="title" [routerLink]="defaultRoute">
            <img class="logo" src="/assets/images/logo.png" height="32" width="88">

            <span class="label">{{label}}</span>
        </a>
    </div>

    <kd-user></kd-user>
</header>
